import { createStyles } from '@mantine/core';

export const useResourceLogStyles = createStyles((theme) => ({
	container: {
		paddingTop: theme.other.space[2],
		paddingLeft: 0,
		margin: 0,
	},
	group: {
		padding: `${theme.other.space[3]}px 0px`,
	},
	item: {
		'::before': {
			top: `calc(20px + ${theme.spacing['3xs']})`,
			bottom: `calc((${theme.spacing.xl} - ${theme.spacing['3xs']}) * -1)`,
			borderColor: theme.other.getColor('border/primary/default'),
			borderWidth: 1,
		},
	},
	itemBullet: {
		'&[data-with-child]': {
			backgroundColor: theme.other.getColor('fill/primary/default'),
			border: 'none',
		},
	},
	root: {
		paddingBottom: theme.other.space[3],
	},
	stack: {
		paddingTop: theme.other.space[3],
	},
}));
